type Listener = () => void;

const listeners = new Set<Listener>();
let open = false;

/** Verdadeiro enquanto o overlay mobile do menu lateral está aberto. */
export function isMobileSidebarOpen(): boolean {
  return open;
}

function notify(): void {
  listeners.forEach((listener) => listener());
}

/** Abre o overlay mobile do menu lateral (acionado pelo botão hamburguer da navbar). */
export function openMobileSidebar(): void {
  open = true;
  notify();
}

/** Fecha o overlay mobile do menu lateral (botão de fechar, clique no backdrop ou navegação). */
export function closeMobileSidebar(): void {
  open = false;
  notify();
}

/** Alterna o overlay mobile do menu lateral. */
export function toggleMobileSidebar(): void {
  open = !open;
  notify();
}

// Navbar e Sidebar são irmãos sem contexto compartilhado (mesma limitação
// documentada em tenant-change.ts); este pub-sub é o que faz o clique no
// hamburguer da Navbar refletir no overlay da Sidebar.
/** Inscreve um listener para mudanças no overlay mobile; retorna a função de cancelamento. */
export function subscribeMobileSidebar(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
